/* eslint-disable */
import _m0 from 'protobufjs/minimal';

export const protobufPackage = 'com.celertech.marketmerchant.api.configuration.services';

export interface SecurityPairInfo {
    assetType: string;
    securityId: string;
    productType: string;
    streamCode: string;
}

export interface ServerAckEvent {
    messageText: string;
}

function createBaseSecurityPairInfo(): SecurityPairInfo {
    return { assetType: '', securityId: '', productType: '', streamCode: '' };
}

export const SecurityPairInfo = {
    encode(message: SecurityPairInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.assetType !== '') {
            writer.uint32(10).string(message.assetType);
        }
        if (message.securityId !== '') {
            writer.uint32(18).string(message.securityId);
        }
        if (message.productType !== '') {
            writer.uint32(26).string(message.productType);
        }
        if (message.streamCode !== '') {
            writer.uint32(34).string(message.streamCode);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): SecurityPairInfo {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSecurityPairInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.assetType = reader.string();
                    break;
                case 2:
                    message.securityId = reader.string();
                    break;
                case 3:
                    message.productType = reader.string();
                    break;
                case 4:
                    message.streamCode = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<SecurityPairInfo>): SecurityPairInfo {
        const message = createBaseSecurityPairInfo();
        message.assetType = object.assetType ?? '';
        message.securityId = object.securityId ?? '';
        message.productType = object.productType ?? '';
        message.streamCode = object.streamCode ?? '';
        return message;
    }
};

function createBaseServerAckEvent(): ServerAckEvent {
    return { messageText: '' };
}

export const ServerAckEvent = {
    encode(message: ServerAckEvent, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
        if (message.messageText !== '') {
            writer.uint32(10).string(message.messageText);
        }
        return writer;
    },

    decode(input: _m0.Reader | Uint8Array, length?: number): ServerAckEvent {
        const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseServerAckEvent();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.messageText = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },

    fromPartial(object: DeepPartial<ServerAckEvent>): ServerAckEvent {
        const message = createBaseServerAckEvent();
        message.messageText = object.messageText ?? '';
        return message;
    }
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
    ? T
    : T extends Array<infer U>
    ? Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
    ? ReadonlyArray<DeepPartial<U>>
    : T extends {}
    ? { [K in keyof T]?: DeepPartial<T[K]> }
    : Partial<T>;
